
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"61","height":"61"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 1517","transform":"translate(-403 -563)"}},[_c('rect',{attrs:{"data-name":"Rectangle 1273","width":"61","height":"61","rx":"5","transform":"translate(403 563)","fill":"#f9fafb"}}),_c('g',{attrs:{"data-name":"Groupe 1488","fill":"#044370","stroke":"#044370","stroke-width":".5"}},[_c('path',{attrs:{"data-name":"Tracé 6779","d":"M416.652 590.76l2.748 3.266a.625.625 0 00.88.076l3.156-2.656v15.931a.625.625 0 00.625.625h21.6a.625.625 0 00.625-.625v-15.536l2.685 2.264a.624.624 0 00.88-.076l2.75-3.266a.625.625 0 00-.075-.88l-17.5-14.733a.626.626 0 00-.805 0l-17.494 14.729a.625.625 0 00-.075.881zm28.385.03v15.962h-20.349v-16.358l9.941-8.369zm-10.412-14.348l16.618 13.991-1.943 2.31-14.269-12.013a.624.624 0 00-.805 0l-14.271 12.013-1.945-2.31z"}}),_c('path',{attrs:{"data-name":"Tracé 6780","d":"M434.42 604.341a.625.625 0 00.884 0l6.174-6.174a4.99 4.99 0 00-6.615-7.45 4.99 4.99 0 00-6.616 7.45zm-5.289-12.347a3.74 3.74 0 015.29 0 .625.625 0 00.884 0 3.74 3.74 0 015.29 5.289l-5.732 5.732-5.732-5.731a3.74 3.74 0 010-5.289z"}})])])])
          )
        }
      }
    